import React from "react";
import clsx from "clsx";
import { IonIcon } from "@ionic/react";

import { TNameStatus, TeacherGearboxDirectory } from "../../state";
import folderIcon from "../../assets/icons/folder_white.svg";

import styles from "./BoxTitle.module.scss";

type BoxTitleProps = {
  title: string | JSX.Element;
  year?: number;
  isSubjectBox?: boolean;
  isArchived?: boolean;
  isSubmissionPrivate?: boolean;
  nameStatus?: TNameStatus;
  wrap?: boolean;
  className?: string;
  gearboxDirectoryIds?: number[];
  teacherGearboxDirectories?: TeacherGearboxDirectory[];
};

const BoxTitle = (props: BoxTitleProps) => {
  const boxTitle =
    typeof props.title === "string" && props.isSubjectBox && props.year
      ? `${props.title}_${props.year}`
      : props.title;

  const directoryIds = props.gearboxDirectoryIds ?? [];
  const teacherDirectories = props.teacherGearboxDirectories ?? [];
  const directories = directoryIds
    .map(id => teacherDirectories.find(directory => directory.id === id))
    .filter(
      (directory): directory is TeacherGearboxDirectory =>
        directory !== undefined,
    );

  return (
    <span
      className={clsx(
        styles.wrapper,
        !props.wrap && styles.nowrap,
        props.className,
      )}
    >
      {props.isArchived && (
        <span className={clsx(styles.label, styles.tag)}>提出終了</span>
      )}
      {props.nameStatus === "unpublish" && (
        <span className={clsx(styles.label, styles.tag)}>匿名共有</span>
      )}
      {props.isSubmissionPrivate && (
        <span className={clsx(styles.label, styles.submissionPrivateTag)}>
          非共有BOX
        </span>
      )}
      {directories.map(directory => (
        <span
          key={directory.id}
          className={clsx(styles.label, styles.directoryLabel)}
        >
          <IonIcon className={styles.icon} src={folderIcon} />
          {directory.name}
        </span>
      ))}
      <span className={styles.boxTitle}>{boxTitle}</span>
    </span>
  );
};

export default BoxTitle;
